<div class="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-5">
  @for (owner of owners; track owner) {
    <div>
      <app-membership-owner
        [owner]="owner"
        [showAction]="false"
        (onActionClick)="viewOwnerDetail($event)"
        />
      </div>
    }
  </div>

  <!-- <app-button
    [type]="'button'"
    [label]="'BUTTONS.ADD_OWNER' | translate"
    classesName="btn-edge-cut mt-8 mb-8"
    (onBtnClick)="isOwnerModalOpen = true"
    /> -->

    <!-- Add Owner/Manager Modal -->
    @if (isOwnerModalOpen) {
      <div class="dc-modal">
        <div class="dc-modal-container">
          <!-- Close Button -->
          <button
            class="modal-x-button"
            type="button"
            (click)="isOwnerModalOpen = false"
            >
            <i class="fas fa-close"></i>
          </button>
          <!-- Modal Header -->
          <h1 class="section-heading">
            {{ "OWNER_FORM.TITLE" | translate }}
          </h1>
          <!-- content -->
          <app-add-owner-partner
            [(isOpen)]="isOwnerModalOpen"
            (onBtnClick)="onOwnerSubmit($event)"
            [data]="selectedOwner"
            [srFolder]="documents"
            [showAction]="false"
          ></app-add-owner-partner>
        </div>
      </div>
    }
